import { BillingConfig, BillingConfigNames } from "@lib/types/BillingConfig";
import {
  PaginationType,
  UseMutationProps,
  UseQueryProps,
} from "@lib/types/Api";
import ScanConfig from "./ScanConfig";

export type ConfigComponentProps = {
  config: BillingConfig;
  query: UseQueryProps<PaginationType<BillingConfig>>;
  updateQuery: UseMutationProps<Partial<BillingConfig>>;
};

export default function ConfigComponent(props: ConfigComponentProps) {
  switch (props?.config?.name) {
    case BillingConfigNames.scanConfig:
      return <ScanConfig {...props} />;

    default:
      return <>config is not configured</>;
  }
}
